// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";

var defaultLineColour = "#1E90FF";

function make_props(path, visibleOpt, colorOpt, opacityOpt, weightOpt, ref, param) {
  var visible = visibleOpt !== undefined ? visibleOpt : true;
  var color = colorOpt !== undefined ? Caml_option.valFromOption(colorOpt) : defaultLineColour;
  var opacity = opacityOpt !== undefined ? Caml_option.valFromOption(opacityOpt) : 1.0;
  var weight = weightOpt !== undefined ? Caml_option.valFromOption(weightOpt) : 4;
  return {
          path: path,
          color: color,
          visible: visible,
          opacity: opacity,
          weight: weight,
          ref: ref
        };
}

var defaultOpacity = 1.0;

var defaultWeight = 4;

var defaultVisibileStaus = true;

export {
  defaultOpacity ,
  defaultWeight ,
  defaultLineColour ,
  defaultVisibileStaus ,
  make_props ,
  
}
/* No side effect */
